<template>
  <div>
    <Banner heading="Settings"
            subtitle="Configure your applications settings."
            icon="settings" />
  </div>
</template>

<script>
  // @ is an alias to /src
  import { Banner } from '@nswdoe/doe-ui-core';

  export default {
    name: 'settings',
    components: {
      Banner
    }
  }
</script>
